import type { PortfolioFollowupSource } from "@repo/shared/types";
import { Link2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useT } from "@/lib/i18n/use-t";
import { formatFollowupSourceLabel } from "./followup-source-label";
import { T } from "./followup-source-notice.i18n";

type FollowupSourceNoticeProps = {
  source: PortfolioFollowupSource;
};

/**
 * QL-309 — page-level notice on a follow-up portfolio naming the account /
 * savings agreement it is linked to, so it reads apart from a manually
 * created portfolio. Shared by the advisor and public portfolio renderers.
 */
export function FollowupSourceNotice({ source }: FollowupSourceNoticeProps) {
  const t = useT(T);
  const label = formatFollowupSourceLabel(source);
  const isAccount = source.kind === "account";

  return (
    <Alert variant="info">
      <Link2 />
      <AlertTitle>{(isAccount ? t.linkedToAccount : t.linkedToSavingsPlan)(label)}</AlertTitle>
      <AlertDescription>
        {isAccount ? t.accountDescription : t.savingsPlanDescription}
      </AlertDescription>
    </Alert>
  );
}
